import React from 'react';
import { Sparkles, Calendar, Zap } from 'lucide-react';
import { PageSection } from '../../../../types';
import { ActionLinkInput } from '../common/ActionLinkInput';

interface ReservationCtaEditorProps {
  section: PageSection;
  onUpdateContent: (updates: any) => void;
}

export const ReservationCtaEditor: React.FC<ReservationCtaEditorProps> = ({ section, onUpdateContent }) => {
  const content = section.content || {};

  return (
    <div className="space-y-6">
      <div className="p-4 rounded-2xl bg-slate-800/40 border border-slate-700/60 space-y-3.5">
        <div className="flex items-center gap-2">
          <Sparkles className="w-3.5 h-3.5 text-blue-400" />
          <h4 className="text-xs font-bold text-slate-200">Rezervasyon & Eylem Çağrısı</h4>
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Üst Rozet</label>
          <input
            type="text"
            value={content.badge ?? 'ERKEN REZERVASYON FIRSATI'}
            onChange={(e) => onUpdateContent({ badge: e.target.value })}
            className="w-full bg-slate-900 border border-slate-700 text-xs font-semibold text-slate-200 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
          />
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Manşet Başlığı</label>
          <input
            type="text"
            value={content.title ?? 'Hayalinizdeki Seyahati Bugün Planlayın'}
            onChange={(e) => onUpdateContent({ title: e.target.value })}
            className="w-full bg-slate-900 border border-slate-700 text-xs font-bold text-slate-100 px-3 py-2 rounded-xl outline-none focus:border-blue-500"
          />
        </div>

        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-slate-400">Açıklama</label>
          <textarea
            value={content.description ?? ''}
            onChange={(e) => onUpdateContent({ description: e.target.value })}
            rows={2}
            className="w-full bg-slate-900 border border-slate-700 text-xs text-slate-200 p-2.5 rounded-xl outline-none focus:border-blue-500 resize-none"
          />
        </div>
      </div>

      {/* CTA Button */}
      <ActionLinkInput
        label="Rezervasyon Eylem Butonu"
        buttonText={content.buttonText ?? 'Rezervasyon Oluştur'}
        onButtonTextChange={(txt) => onUpdateContent({ buttonText: txt })}
        linkType={content.buttonLinkType || 'page'}
        onLinkTypeChange={(type) => onUpdateContent({ buttonLinkType: type })}
        linkValue={content.buttonLink || '/rezervasyon'}
        onLinkValueChange={(val) => onUpdateContent({ buttonLink: val })}
        whatsappPhone={content.whatsappPhone}
        onWhatsappPhoneChange={(phone) => onUpdateContent({ whatsappPhone: phone })}
        whatsappMessage={content.whatsappMessage}
        onWhatsappMessageChange={(msg) => onUpdateContent({ whatsappMessage: msg })}
      />
    </div>
  );
};
